import Flex from "@shared/components/Flex";

export default Flex;
